import { translate } from "app/language/service"
import { getStore } from "app/store/store"
import { CAMPAIGN_STATUSES, ICampaign } from "campaign/model"
import { campaignRPO } from "campaign/repository"
import { campaignActionCreator } from "campaign/store/actions"
import { getDspDealByCampaignId } from "dsp-deal/tools/common"
import { messageSVC } from "message/service"
import { refreshCampaignListInStore } from "./save"

export const loadListDspDeal = (): Promise<void> => {
  return new Promise<void>(async resolve => {
    try {
      const filteredEntities = getStore().getState().campaign.dspDealList.filteredEntities
      if (filteredEntities.length === 0) {
        return
      }
      getStore().dispatch(campaignActionCreator.setList(false, true, { isLoadingDspDeal: true }))
      const dspDealByCampaignId = await getDspDealByCampaignId(filteredEntities.map(c => c.id))
      getStore().dispatch(campaignActionCreator.setListCampaignsDspDeal(dspDealByCampaignId))
      resolve()
    } catch (error) {
      console.error(error)
      getStore().dispatch(campaignActionCreator.setList(false, false, { isLoadingDspDeal: false }))
      messageSVC.error(translate("campaign.dsp-deal.error"))
      resolve()
    }
  })
}

export const toggleDspDealStatus = (campaign: ICampaign, refreshList: boolean): Promise<CAMPAIGN_STATUSES | null> => {
  const activate = campaign.status_id !== CAMPAIGN_STATUSES.ACTIVE
  return new Promise<CAMPAIGN_STATUSES | null>((resolve, reject) => {
    messageSVC.confirmMessage({
      title: translate(activate ? "dsp-deal.activate.title" : "dsp-deal.deactivate.title"),
      addGenericConfirmMessage: true,
      message: translate(
        activate ? "dsp-deal.active.confirm.message" : "dsp-deal.deactivate.confirm.message",
        campaign.product || ""
      ),
      onSuccess: async () => {
        const newStatus = activate ? CAMPAIGN_STATUSES.ACTIVE : CAMPAIGN_STATUSES.CANCELLED
        const updatedCampaign = await campaignRPO.update({
          id: campaign.id,
          status_id: newStatus
        })
        if (refreshList) {
          updatedCampaign.dspDeal = campaign.dspDeal
          refreshCampaignListInStore(updatedCampaign, true)
        }
        resolve(newStatus)
      },
      onCancel: () => resolve(null)
    })
  })
}
